/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1BundleRequest {
    /**
    * The path to the policy you would like to bundle.
    */
    'policyPath'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "policyPath",
            "baseName": "policy_path",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1BundleRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

